/*! React Starter Kit | MIT License | http://www.reactstarterkit.com/ */

import React from 'react'; // eslint-disable-line no-unused-vars
import PropTypes from 'prop-types';
import styles from './Offer.scss';
import datePickerCss from '../../../../node_modules/react-datepicker/dist/react-datepicker.min.css';
import BaseReactComponent from '../../Util/BaseReactComponent';
import baseComponent from '../../../decorators/baseComponent';
import LinkedStateMixin from 'react-addons-linked-state-mixin';
import DatePicker from 'react-datepicker';
import moment from 'moment';
import reactMixin from 'react-mixin';

@baseComponent(datePickerCss)
@baseComponent(styles) @reactMixin.decorate(LinkedStateMixin) class Offer extends BaseReactComponent {

    constructor(props) {
        super(props);

        this.state = {};
        this.state.url = '';
        this.state.activationDate = undefined;
        this.state.endOfLifeDate = undefined;
        this.state.country = 'BELGIUM';
    }


    componentDidMount() {
        this.updateOffer(this.props);
    }

    componentWillReceiveProps(nextProps) {
        this.updateOffer(nextProps);
    }

    updateOffer(props) {
        let offer = props.commercialOffer;
        offer.activationDate = moment(offer.activationDate);
        offer.endOfLifeDate = moment(offer.endOfLifeDate);

        if (!offer.activationDate.isValid()) {
            offer.activationDate = undefined;
        }

        if (!offer.endOfLifeDate.isValid()) {
            offer.endOfLifeDate = undefined;
        }


        this.setState(offer);
    }

    handleActivationDateChange(date) {
        let currentState = this.copyState();
        currentState.activationDate = date;

        this.setState(currentState);

        this.props.handleOfferChanged(currentState);
    }

    handleEndOfLifeDateChange(date) {
        let currentState = this.copyState();
        currentState.endOfLifeDate = date;

        this.setState(currentState);

        this.props.handleOfferChanged(currentState);
    }

    handleUrlChange(event) {
        let currentState = this.copyState();
        currentState.url = event.currentTarget.value;

        this.setState(currentState);

        this.props.handleOfferChanged(currentState);
    }

    copyState() {
        let currentState = JSON.parse(JSON.stringify(this.state));
        currentState.activationDate = moment(currentState.activationDate);
        currentState.endOfLifeDate = moment(currentState.endOfLifeDate);
        if (!currentState.activationDate.isValid()) {
            currentState.activationDate = '';
        }

        if (!currentState.endOfLifeDate.isValid()) {
            currentState.endOfLifeDate = '';
        }
        return currentState;
    }

    render() {
        let self = this;

        return (
            <div className="form-group clearfix">
                <label className="col-sm-2 control-label">{self.getIntlMessage('country.' + this.state.country)}</label>

                <div className="col-sm-6">
                    <input type="url" className="validate form-control" value={this.state.url} onChange={self.handleUrlChange.bind(self)}/>
                </div>

                <div className="col-sm-2">
                    <DatePicker selected={this.state.activationDate} onChange={self.handleActivationDateChange.bind(self)} className="form-control datepicker" placeholderText={self.getMessage('activation-date-placeholder')}/>
                </div>

                <div className="col-sm-2">
                    <DatePicker selected={this.state.endOfLifeDate} onChange={self.handleEndOfLifeDateChange.bind(self)} className="form-control datepicker" placeholderText={self.getMessage('end-date-placeholder')}/>
                </div>
            </div>
        );
    }
}

Offer.PropTypes = {
    commercialOffer: React.PropTypes.object,
    saveCommercialOffer: React.PropTypes.func,
    handleOfferChanged: React.PropTypes.func
};

export default Offer;



// WEBPACK FOOTER //
// /src/components/CommercialOffers/Offer/Offer.js